import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { bookingApi, unwrap } from '@/lib/api/client';

/**
 * Booking payment history — every payment taken for a booking, oldest report on
 * the site and the flattest.
 *
 * From docs/booking-api.swagger.json: `BookingPaymentHistoryModel` in,
 * `BookingPaymentHistoryDto` out.
 */

export interface PaymentHistoryModel {
  searchTerm: string;
  /** Both optional: null on either side leaves that end of the range open. */
  startDate: string | null;
  endDate: string | null;
  eventType: number | null;
  serviceTypeId: string | null;
  page: number;
  size: number;
}

/** `BookingPurchaseHistoryDto`. */
export interface PaymentHistoryRow {
  id: string;
  paidOn: string | null;
  cancelled: boolean;
  createdAt: string | null;
  startTime: string | null;
  endTime: string | null;
  amount: number | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  eventName: string | null;
}

/** `BookingPaymentHistoryDto`. No `page`/`size` echo — only the total. */
export interface PagedPaymentHistory {
  total: number | null;
  payments: PaymentHistoryRow[] | null;
}

export function usePaymentHistory(model: PaymentHistoryModel) {
  return useQuery({
    queryKey: ['booking-payment-history', model],
    queryFn: () =>
      unwrap<PagedPaymentHistory>(
        bookingApi.post('admin/payments/history', model)
      ),
    placeholderData: keepPreviousData,
  });
}
